import { createContext, useContext, useEffect, useState } from "react";
import { COPY } from "@/content/site";
import { FAQ } from "@/content/media";

const LangCtx = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => {
    const param = new URLSearchParams(window.location.search).get("lang");
    if (param === "es" || param === "en") return param;
    const saved = localStorage.getItem("ec-lang");
    return saved === "es" || saved === "en" ? saved : "en";
  });

  useEffect(() => {
    localStorage.setItem("ec-lang", lang);
    document.documentElement.lang = lang;
    const meta = document.querySelector('meta[name="description"]');
    if (meta) meta.setAttribute("content", COPY[lang].meta);
    const faqLd = document.getElementById("faq-ld");
    if (faqLd) {
      faqLd.textContent = JSON.stringify({
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: FAQ[lang].items.map((f) => ({
          "@type": "Question",
          name: f.q,
          acceptedAnswer: { "@type": "Answer", text: f.a },
        })),
      });
    }
  }, [lang]);

  const value = {
    lang,
    setLang,
    t: COPY[lang] || COPY.en,
    isEs: lang === "es",
  };
  return <LangCtx.Provider value={value}>{children}</LangCtx.Provider>;
}

export const useLang = () => useContext(LangCtx);
